export default "__VITE_ASSET__BwEvC7Bj__"